'use strict';

var stringify = require('./stringify.js');

var renderer = function renderer(root) {
  var content = typeof root === 'string' ? document.getElementById(root) : root;
  return function (ml) {
    var str;

    try {
      str = stringify(ml);
      content.innerHTML = str;
    } catch (err) {
      console.log(ml);
    }
  };
};

module.exports = renderer;
/* eslint-env browser */